import config from '../config.js';
import resource from "../../model/resource.js";

//检查文件是否合法
function checkFiles(params, success){
	let files = params.files.tempFiles;
	let idx = 0;
	let errFiles = [];
	
	for(let i in files)
	{
		let file = files[i];
				
		if(params.type == 'hotspotImage') {
			dyEditor.util.imageScale({
				file 	: file,
				width	: 2000,
				success	: img=>{		
					files[i] = img;
					
					//检查完成
					if(idx++ >= files.length -1) {
						files = files.filter(item => {
						    return !item.err;
						});
						
						if(errFiles.length>0){
							dyEditor.dialog.files({
								title:'系统提示',
								height:'550px',
								files:errFiles
							});
						}
						
						success && success(files);
					}
				}
			});
		} else {
			if(params.maxSize && file.size > params.maxSize){
				file.err = true;
				errFiles.push({
					name: file.name,
					text: '文件超出' + parseInt(params.maxSize/(1024*1024)) + 'MB的最大限制，无法上传',
				});
			}
			
			if(params.max && i>=params.max){
				file.err = true;
				errFiles.push({
					name: file.name,
					text: '超出最大数量上限，无法上传',
				});
			}
			
			//检查完成
			if(idx++ >= files.length -1) {
				files = files.filter(item => {
				    return !item.err;
				});
						
				if(errFiles.length>0){
					dyEditor.dialog.files({
						title:'系统提示',
						height:'550px',
						files:errFiles
					});
				}
				
				success && success(files);
			}
		}
	}
}

//上传图册图片
function uploadImage(params){
	checkFiles(params, files=>{
		resource.uploadFiles(dy3d.config.id, files, {
			type : params.type,
			ready : res=>{
				let item = {id:res.id, name:res.name, size:res.size, file:res.file};
				params.button.target.images.push(item);
				return params.button.target.images[params.button.target.images.length - 1];
			},
			success	: res=>{
				res.item.progress	= 0;
				res.item.url = dy3d.manager.getPath() + res.item.file;
				params.success && params.success(files);
			},
			progress : res=>{
				res.item.progress = res.num;
				params.progress && params.progress(res.num);
			},
			error : res=>{
				params.error && params.error(res);
				dyEditor.toast.error('图片上传失败!');
			}
		});
	});
}

//上传视频
function uploadVideo(params){
	checkFiles(params, files=>{
		resource.uploadFiles(dy3d.config.id, files, {
			type : params.type,
			ready : res=>{
				let item = {id:res.id, name:res.name, size:res.size, file:res.file};
				params.button.target.videos.push(item);
				return params.button.target.videos[params.button.target.videos.length-1];
			},
			success	: res=>{
				res.item.progress	= 0;
				res.item.url		= dy3d.manager.getPath() + res.item.file;
				res.item.preview	= res.item.url.replace('.mp4', '.jpg');
				
				params.success && params.success(files);
			},
			progress : res=>{
				res.item.progress = res.num;
				params.progress && params.progress(res.num);
			},
			error : res=>{
				params.error && params.error(res);
				dyEditor.toast.error('视频上传失败!');
			}
		});
	});
}

//上传图片图标
function uploadIconImage(params){			
	dyEditor.util.imageScale({
		file 	: params.file.tempFiles[0],
		width	: 32,
		success	: img=>{		
			resource.upload({
				file	: img,
				form	: {
					"id": dy3d.config.id,
					'type':'hotspotIconImage'
				},
				success:(r)=>{
					params.button.icon		= dy3d.manager.getPath() + r.file;
					params.button.width		= 32;
					params.button.height	= 32;
					params.button.size		= img.size;
					params.button.status	= 1;
				},
				progress:(res)=>{
					params.progress && params.progress(res);
				},
				error:(res)=>{
					params.error && params.error(res);
					dyEditor.toast.error('自定义按钮图标上传失败!');
				}
			});
		}
	});
}
//上传导览按钮图标
function uploadnaviBtnImage(params){			
	dyEditor.util.imageScale({
		file 	: params.file.tempFiles[0],
		width	: 32,
		success	: img=>{		
			resource.upload({
				file	: img,
				form	: {
					"id": dy3d.config.id,
					'type':'hotspotIconImage'
				},
				success:(r)=>{
					params.button.icon		= dy3d.manager.getPath() + r.file;
					params.button.width		= 32;
					params.button.height	= 32;
					params.button.size		= img.size;
					params.button.status	= 1;
				},
				progress:(res)=>{
					params.progress && params.progress(res);
				},
				error:(res)=>{
					params.error && params.error(res);
					dyEditor.toast.error('导览按钮图标上传失败!');
				}
			});
		}
	});
}
//上传图片图标
function uploadFlyIconImage(params){			
	dyEditor.util.imageScale({
		file 	: params.file.tempFiles[0],
		width	: 32,
		success	: img=>{		
			resource.upload({
				file	: img,
				form	: {
					"id": dy3d.config.id,
					'type':'hotspotIconImage'
				},
				success:(r)=>{
					params.button[params.buttonType].icon = dy3d.manager.getPath() + r.file;
					params.button.size		= img.size;
				},
				progress:(res)=>{
					params.progress && params.progress(res);
				},
				error:(res)=>{
					params.error && params.error(res);
					dyEditor.toast.error('自定义按钮图标上传失败!');
				}
			});
		}
	});
}

//上传联系人头像
function uploadFace(params){
	dyEditor.util.imageScale({
		file 	: params.file.tempFiles[0],
		width	: 100,
		success	: img=>{		
			resource.upload({
				file	: img,
				form	: {
					"id": dy3d.config.id,
					'type':params.type,
				},
				success:(r)=>{
					params.data.url		= dy3d.manager.getPath() + r.file;
					params.data.size	= img.size;
				},
				progress:(res)=>{
					params.progress && params.progress(res);
				},
				error:(res)=>{
					params.error && params.error(res);
					dyEditor.toast.error('头像上传失败!');
				}
			});
		}
	});
}

export default {
	uploadImage,
	uploadVideo,
	uploadFace,
	uploadIconImage,
	uploadFlyIconImage,
	uploadnaviBtnImage,
}